import { SearchTerm } from "./SearchTerm";

const CertificateAuditSearch: SearchTerm[] = [
    {
        heading: "Operator",
        accessor: "operator",
        searchOnName: "operator",
        translationKey: "operator"
    },
    {
        heading: "Action",
        accessor: "action",
        searchOnName: "action",
        translationKey: "action"
    },
    {
        heading: "Before",
        accessor: "valueOld",
        searchOnName: "valueOld",
        translationKey: "before"
    },
    {
        heading: "After",
        accessor: "valueNew",
        searchOnName: "valueNew",
        translationKey: "after"
    }
];

export default CertificateAuditSearch;
